import Vue from 'vue';
import VueRouter from 'vue-router';
import App from '@/components/App.vue';
import routes from './routes';
import store from './store';

import Axios from 'axios';
import { createLogger } from 'browser-bunyan';
import { ConsoleFormattedStream } from '@browser-bunyan/console-formatted-stream';
import BootstrapVue from 'bootstrap-vue';
import dayjs from 'dayjs';
import VueAsyncComputed from 'vue-async-computed';
import VueJWT from 'vuejs-jwt';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Loader from '@/components/shared/Loader';
import ConfirmModal from '@/components/shared/ConfirmModal';
import ErrorModal from '@/components/shared/ErrorModal';
import ProcessingModal from '@/components/shared/ProcessingModal';

import '@/assets/scss/custom.scss';

Vue.prototype.$dayjs = dayjs;
Vue.prototype.$http = Axios;
Vue.prototype.$logger = createLogger({
	name: 'Propeller Platform Portal',
	stream: new ConsoleFormattedStream({ logByLevel: true }),
	level: 'info'
});

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueAsyncComputed);
Vue.use(BootstrapVue);
Vue.use(VueJWT);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('elumin-loader', Loader);
Vue.component('ConfirmModal', ConfirmModal);
Vue.component('ErrorModal', ErrorModal);
Vue.component('ProcessingModal', ProcessingModal);

let router = new VueRouter({
	routes
});

if(window.location.protocol != 'https:')
	location.href = location.href.replace("http://", "https://");

window.vm = new Vue({
	render: h => h(App, { ref: "app" }),
	router,
	store
}).$mount('#app');
